<template>
  <div id="app">
    <HeaderCompo />
    <template>
      <div
        id="about_page"
        class="container"
      >
        <div class="box about">
          <center>
            <h3 id="about_title">
              About Us
            </h3>
            <p>
              This little colorful factory of Quizzes started a few months ago just for fun and well.. thankfully is still up and running to this day, fueled by refined 100% pure fun and a bit of code nonsense (aka spaghetti code) here and there. If you smiled at least once while creating or maybe answering one of your friend's Quizzes, then our job is done.
              <br>
              <br>We hope to see you back soon btw or maybe hear from you don't be shy we'll be waiting for your email at <a href="mailto:bestiefy@gmail.com">
                bestiefy@gmail.com
              </a>.
            </p>
          </center>
        </div>
        <div
          id="div_delete_button"
          class="delete_button_shadow go_back_button"
        >
          <button
            id="backButton"
            class="fullWidthButton button_2 pushdown "
            type="button"
            @click="goBack()"
          >
            {{ $t("answers.back") }}
          </button>
        </div>
      </div>
    </template>
    <FlyCompo />
    <FooterCompo />
  </div>
</template>

<script>
import HeaderCompo from '@/components/HeaderCompo.vue'
import FooterCompo from '@/components/FooterCompo.vue'
import FlyCompo from '@/components/FlyCompo.vue'

export default {
  name: 'About',
  components: {
    HeaderCompo,
    FooterCompo,
    FlyCompo
  },
  methods: {
    goBack () {
      window.location.href = '/'
    }
  }
}
</script>

<style lang="scss">
</style>
